// Author thq
// Date 2021-10-25 17:36:27

class EmAclUserJob {
constructor({
        id = null,
        sid = '',
        pkGroup = '',
        pkOrg = '',
        code = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sid = sid;
    this.pkGroup = pkGroup;
    this.pkOrg = pkOrg;
    this.code = code;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new EmAclUserJob();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emAclUserJob.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sid',
        label: 'label.em.admin.emAclUserJob.grid.sid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkGroup',
        label: 'label.em.admin.emAclUserJob.grid.pkGroup',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkOrg',
        label: 'label.em.admin.emAclUserJob.grid.pkOrg',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAclUserJob.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclUserJob.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclUserJob.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sidFilter : '',
    pkGroupFilter : '',
    pkOrgFilter : '',
    codeFilter : '',
    nameFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sidFilter',
        label: 'label.em.admin.emAclUserJob.filter.sid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkGroupFilter',
        label: 'label.em.admin.emAclUserJob.filter.pkGroup',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkOrgFilter',
        label: 'label.em.admin.emAclUserJob.filter.pkOrg',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.admin.emAclUserJob.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAclUserJob.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.admin.emAclUserJob.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkGroup',
        label: 'label.em.admin.emAclUserJob.entity.pkGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkOrg',
        label: 'label.em.admin.emAclUserJob.entity.pkOrg',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAclUserJob.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAclUserJob.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAclUserJob.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAclUserJob, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
